var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 222,
    viewBox: "0 0 222 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222 111C222 172.304 172.304 222 111 222C49.6964 222 0 172.304 0 111C0 49.6964 49.6964 0 111 0C172.304 0 222 49.6964 222 111ZM17.76 111C17.76 162.495 59.505 204.24 111 204.24C162.495 204.24 204.24 162.495 204.24 111C204.24 59.505 162.495 17.76 111 17.76C59.505 17.76 17.76 59.505 17.76 111Z",
    fill: "#36807E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCircle);
export default __webpack_public_path__ + "static/media/smallCircle.42c6a67172feb2e3740349b26392a77e.svg";
export { ForwardRef as ReactComponent };